<ng-container *ngIf="state$ | async as state">
  <div *ngIf="state.breadcrumbs !== undefined"
       [ngClass]="state.breadcrumbs?.[0]?.color ?? ''"
       class="section nav-breadcrumb"
       data-cy="breadcrumbs"
       id="breadcrumb"
  >
    <div class="container">
      <ol *ngIf="state.breadcrumbs?.length"
          class="breadcrumb"
          data-cy="breadcrumbs-list"
      >
        <ng-container *ngFor="let breadcrumb of state.breadcrumbs; index as i">
          <ng-container *ngTemplateOutlet="breadcrumb?.link?.length ? withLink : withoutLink;
                                             context: { breadcrumb: breadcrumb, breadcrumbs: state.breadcrumbs, isLG: state.isLG, index: i}"
          ></ng-container>
        </ng-container>
      </ol>
    </div>
  </div>
</ng-container>

<ng-template #withoutLink
             let-breadcrumb="breadcrumb"
             let-index="index"
>
  <li [attr.data-cy]="'breadcrumb-item-' + index"
      [innerHTML]="breadcrumb?.label | safeHtml"
  ></li>
</ng-template>
<ng-template #withLink
             let-breadcrumb="breadcrumb"
             let-breadcrumbs="breadcrumbs"
             let-index="index"
             let-isLG="isLG"
>
  <li [attr.data-cy]="'breadcrumb-item-' + index">
    <mb-link [dataEventAction]="'Click: ' + breadcrumb?.label"
             [dataEventLabel]="'Source: ' + breadcrumbs?.[breadcrumbs?.length - 1]?.label"
             [linkData]="$any({ url: breadcrumb?.link, uid: 'content_link', text: (!isLG ? '&lt;- ' : '') + breadcrumb.label })"
             dataEventCategory="Breadcrumb navigation"
    ></mb-link>
  </li>
</ng-template>
